module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h1', [_vm._v("About the Author")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Azzedine Kechroud was born on 11 February 1946 in Algiers, Algeria. He has a degree in private law. He is a writer, novelist and poet. He started writing when he was young but began publishing later. He lives in England as a British citizen with his family and grandsons. He is retired.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0